import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="AR & VR Apps">
                <h1>AR & VR App Development Company</h1>
              </div>
              <p className="main_para">
                Explore the untapped potential through next-gen mixed reality
                tools.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                An AR/VR app development company to create otherworldly
                experiences and cater to next-gen digital media enthusiasts.
              </p>
              <ul>
                <li>Augmented Reality</li>
                <li>Virtual Reality</li>
                <li>360° Video Perspectives</li>
                <li>App Support &amp; Maintenance</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
